export default __webpack_public_path__ + "static/media/Power_Małgorzata Szmigiel_rok liturgiczny.6594a484.pdf";